import { addDays, format, startOfWeek } from "date-fns";

import { config } from "shared/data";

export const getRecommendParameters = () => {
  if (config.general.env === "production" || config.general.env === "preprod") {
    return;
  }

  const now = startOfWeek(new Date(), { weekStartsOn: 0 });
  const startDate = addDays(now, -14);
  const endDate = addDays(startDate, 6);

  return {
    recall: {
      endDate: format(endDate, "yyyy-MM-dd"),
      startDate: format(startDate, "yyyy-MM-dd"),
    },
  };
};
